import React, { useEffect } from 'react'
import { Button, Card, Col, Container, Form, FormSelect, ListGroup, ListGroupItem, Row } from 'shards-react'
import ConfirmAlert from '../../../components/common/ConfirmAlert'
import InputBox from '../../../components/common/InputBox'
import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { connect } from 'react-redux'
import { get_client_project_by_refnum, get_sub_client_project_list, get_sub_project_status_list, reset_client_project_details, save_subscriber_client_project } from '../../../redux/actions/subscriber/project'
import { NavgationPageLocationKey } from '../../../utils/constants'
import { get_client_list } from '../../../redux/actions/user'

const AddEditProject = ({ save_subscriber_client_project, get_client_project_by_refnum
    , reset_client_project_details, subClientProjectDetails
    , get_sub_project_status_list, subClientProjectStatusList
    , clientList, get_client_list
 }) => {
    const location = useLocation();
    const [refNum, setrefNum] = useState(0);
    const history = useHistory();
    const [formData, setFormData] = useState({
        refNum: 0,
        clientId: 0,
        projectRefNum: '',
        projectName: '',
        status: '',
    });

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    const clientListOptions = (clientList || []).map(client => <option key={client.clientName + client.clientId} value={client.clientId}>{client.clientName}</option>)

    const onChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        let res = await save_subscriber_client_project({ refNum: formData.refNum
            , clientId: formData.clientId
            , projectName: formData.projectName?.trim()
            , status: formData.status
        })
        if(res)
            history.push({
                pathname: `/search-clients-project`
            });
    };

    const goBack = (e) => {
        e.preventDefault();
        history.push({
            pathname: `/search-clients-project`
        });
    }

    useEffect(() => {
        if (refNum === 0) {
            if (location.state !== undefined) {
                //Take from state --> Also Add screnario will fall here
                let itemId = location.state?.refNum !== undefined ? location.state?.refNum : 0;
                setrefNum(itemId);
                if (Number(itemId) !== 0) {
                    get_client_project_by_refnum(itemId);
                }

                setFormData({
                    ...formData
                    , refNum: itemId
                })
            }
            else if (localStorage.getItem(NavgationPageLocationKey.ProjectCurrentAddEdit) !== null) {
                //Take from local storage 
                let storageRefNum = localStorage.getItem(NavgationPageLocationKey.ProjectCurrentAddEdit);
                setrefNum(storageRefNum);
                get_client_project_by_refnum(storageRefNum)
                //Set state for same page
                const newState = { refNum: storageRefNum }
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.ProjectCurrentAddEdit);
            }
        }
        
        get_client_list();
        //get_sub_client_project_list();
        get_sub_project_status_list();
        return () => {
            reset_client_project_details();
        }
    }, [])

    useEffect(() => {
        setFormData({...formData
            , refNum: refNum
            , clientId: subClientProjectDetails.clientId
            , projectName: subClientProjectDetails.projectName
            , projectRefNum: subClientProjectDetails.projectRefNum
            , status: subClientProjectDetails.status
        });
    }, [subClientProjectDetails])

    var statusList = subClientProjectStatusList?.map((item, i) => {
        return <option key={item + i} value={item}>{item}</option>
    })

    return (
        <Container fluid className="main-content-container p-4">
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Card small className="mb-5 w-100">
                <h4 className="m-0 section-title idStyle">Ref# {refNum}</h4>
                <ListGroup flush>
                    <ListGroupItem className="border-card p-3">
                        <Row>
                            <Col>
                                <Form id="clientDetailsForm" onSubmit={onSubmit}>
                                    <Row form>
                                        <InputBox placeholder="Enter Project Name" label="Project Name" name='projectName' id='projectName'
                                            required={true}
                                            value={formData.projectName}
                                            onChange={onChange} />


                                        <Col lg="3" className="form-group p-2 m-0">
                                            <div className="d-flex flex-row justify-content-between">
                                                <label>Client <span aria-hidden="true" className="required">*</span></label>
                                            </div>
                                            <div className="d-flex flex-row justify-content-between">
                                                <FormSelect value={formData.clientId} id="clientId" required
                                                    name='clientId' onChange={onChange} className=''>
                                                    <option value=''>Select Client</option>
                                                    {clientListOptions}
                                                </FormSelect>
                                            </div>
                                        </Col>

                                        <Col lg="3" className="form-group p-2 mb-0">
                                            <label htmlFor={"status"}>Status <span aria-hidden="true" className="required"> *</span></label>
                                            <span>
                                                <FormSelect size="sm" name='status' className="w-100" value={formData.status} 
                                                    onChange={onChange} required>
                                                    <option value=''>Select Status</option>
                                                    {statusList}
                                                </FormSelect>
                                            </span>
                                        </Col>

                                        <Col lg="3" className="form-group p-2 mb-0">
                                            <div className="d-flex mt-4 pt-2">
                                                <Button className="mr-2" id="btnSave" type="submit">Save</Button>
                                                <Button className="mr-2" id="btnCancel" onClick={goBack}>Cancel</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </ListGroupItem>
                </ListGroup>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    clientList: state.user.clientList,
    subClientProjectDetails: state.project.subClientProjectDetails,
    subClientProjectStatusList: state.project.subClientProjectStatusList,
})

export default connect(mapStateToProps, {
    save_subscriber_client_project,
    get_client_project_by_refnum,
    reset_client_project_details,
    get_sub_project_status_list,
    get_client_list,
})(AddEditProject)
